export const DBStores = {
    ChatRoom: 'ChatRoom',
    ChatRoomMessages: 'ChatRoomMessages',
    HelpRequest: 'HelpRequest'
}